import {ItemModelType} from "@stores/WorkspaceStore";
import { CrudServices } from "../../platform/services/types/ServiceDependencies";
import { UserSessionState } from "@stores/UserSessionState";
import { sendAcknowledgementReminders } from "./sendAcknowledgementReminders";

export const ackNotifyUser = (
    services: CrudServices,
    _userState: UserSessionState,
    userId: string,
    itemMST: ItemModelType
) => {
    return sendAcknowledgementReminders(services, itemMST.id, [userId]);
}
